// extracted by mini-css-extract-plugin
module.exports = {"root":"OfflineContainer-module--root--sBc5J","noConnection":"OfflineContainer-module--no-connection--iJ9fp"};